import { defineAsyncComponent } from "vue";

export default {
  forms: {
    list: {
      component: defineAsyncComponent(() => import("./forms/List.vue")),
    },
    edit: {
      panel: {
        width: "70%",
      },
      component: defineAsyncComponent(() => import("./forms/Edit.vue")),
    },
    select: {},
  },
};
